import { motion } from 'framer-motion';
import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    align-self: end;
    width: 100%;
`;

export const Label = styled.div`
    color: #fff;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
    letter-spacing: -0.24px;
    flex-shrink: 0;
    white-space: nowrap;
    flex-shrink: 0;

    @media (max-width: 768px) {
        display: none;
    }
`;

export const Marquee = styled.div`
    display: flex;
    overflow: hidden;
    width: 100%;
    height: 48px;
    position: relative;

    mask: linear-gradient(90deg, transparent, white 10%, white 90%, transparent);

    @media (max-width: 768px) {
        height: 38px;
    }
`;

export const Track = styled(motion.div)`
    display: flex;
    align-items: center;
    gap: 10px;
    user-select: none;
    width: max-content;
    flex-wrap: nowrap;
    padding-left: 10px;
    position: absolute;
    left: 0;
    top: 0px;
`;
